import React from 'react';
import withRouter from '../../../App/components/withRouter';
import Aux from "../../../hoc/_Aux";
import { connect } from 'react-redux'
import { SET_LOGIN_ADMIN_TOKEN, SET_USER_LOGIN, SET_LOGIN_AUTH_ERROR, VERIFY_USER_MFA, CLEAR_USER_SESSION, FETCH_SAML_SSO_AUTHENTICATE_URL } from '../../../store/actions/auth';
import { COUNTRY_UOM_DATA } from '../../../store/actions/dateFormat';
import Auth from '../../../models/Auth';
import queryString from 'query-string';
import Timer from './../../Utils/Timer';
import { toast } from 'react-toastify';
import { GET_PROGRAM_DATA } from '../../../store/actions/dashboardAction';
import { GET_CLIENT_TERMS, GET_DEFAULT_CULTURE, GET_CULTURE_LIST } from '../../../store/actions/termsPrivacy';
import { cacheService, getLang, getPortalBackgroundUrl, getLanguageFromLocation } from '../../../helper/utils';
import { withTranslation } from 'react-i18next';
import { getJsonLanguage, getMasterDataTranslation, getPortalDataTranslation } from '../../../helper/i18next-utils';
import { GET_PORTAL_LOGO } from "../../../store/actions/portal";
import { PORTAL_INSTANCE } from '../../..';
import { Button, Input, Label } from 'reactstrap';
import { portalLogoUrl } from '../../../helper/utils';
import ForgotUsernamePopup from './ForgotUsernamePopup';
import ForgotPasswordPopup from './ForgotPasswordPopup';
import QRCodeLogin from './QRCodeLogin';
import ResetPasswordPopup from './ResetPasswordPopup';
import { GET_USER_GROUP_BY_USERID } from '../../../store/actions/user';
import ChangePasswordPopup from './ChangePasswordPopup';
import MineError from '../../Commons/MineError';
import SuccessDialog from '../../Commons/SuccessDialog';
import RegisterForm from './RegisterForm';
import { GET_ALL_PROGRAM_LANGUAGES } from '../../../store/actions/homeCustomer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import FooterSignInPopup from './FooterSignInPopup';
import Select from 'react-select';
import { SIDE_MENU_ITEMS } from '../../../App/layout/AdminLayout/Navigation';
import { FILTER_PERMISSION } from '../../../constants/client-permission';

const mapStateToProps = state => {
    return {
        authLoginError: state.auth.authLoginError,
        authErrorCode: state.auth.authErrorCode,
        portalsSameUser: state.auth.portalsSameUser,
        selectedPortalLogo: state.portal.selectedPortalLogo,
        programData: state.allRequest.programData,
        session: state.auth.session,
        mfaType: state.auth.mfaType,
        qrCode: state.auth.qrCode,
        userLocationDetails: state.dateFormat.userLocationDetails,
        countryUOM: state.dateFormat.countryUOM,
        termsPrivacy: state.termsPrivacy.termsPrivacyDetail,
        userGroup: state.user.userGroup || [],
        programCulturesList: state.homeCustomer.programCulturesList
    }
}

const mapDispatchToProps = {
    SET_USER_LOGIN: (payload) => SET_USER_LOGIN(payload),
    SET_LOGIN_ADMIN_TOKEN: (payload) => SET_LOGIN_ADMIN_TOKEN(payload),
    VERIFY_USER_MFA: (payload) => VERIFY_USER_MFA(payload),
    SET_LOGIN_AUTH_ERROR: (message) => SET_LOGIN_AUTH_ERROR(message),
    CLEAR_USER_SESSION: () => CLEAR_USER_SESSION(),
    FETCH_SAML_SSO_AUTHENTICATE_URL: (payload) => FETCH_SAML_SSO_AUTHENTICATE_URL(payload),
    COUNTRY_UOM_DATA: (payload) => COUNTRY_UOM_DATA(payload),
    GET_PROGRAM_DATA: (payload) => GET_PROGRAM_DATA(payload),
    GET_CLIENT_TERMS: (payload) => GET_CLIENT_TERMS(payload),
    GET_DEFAULT_CULTURE: (payload) => GET_DEFAULT_CULTURE(payload),
    GET_CULTURE_LIST: () => GET_CULTURE_LIST(),
    GET_PORTAL_LOGO: (payload) => GET_PORTAL_LOGO(payload),
    GET_USER_GROUP_BY_USERID: (payload) => GET_USER_GROUP_BY_USERID(payload),
    GET_ALL_PROGRAM_LANGUAGES: (payload) => GET_ALL_PROGRAM_LANGUAGES(payload),
}

class SignIn extends React.Component {
    constructor(props) {
        super(props);
        let { cId, pId } = PORTAL_INSTANCE
        const query = new URLSearchParams(this.props.location.search);
        const forgotpasswordtoken = query.get('forgotpasswordtoken')
        const username = query.get('username')
        this.state = {
            portalId: pId,
            clientId: cId,

            username: username || '',
            password: '',
            forgotUserNameEmail: '', // email
            acceptTerms: false,
            rememberMe: false,

            error: '',

            MFA_TYPES: ['SMS_MFA', 'SOFTWARE_TOKEN_MFA'],
            showLoginTimer: false,
            logRemainTimerMin: 0,
            logRemainTimerSec: 0,
            readyToUseReason: '',
            compDidMount: false,

            portalsSameUser: [],
            selectedPortalId: '',
            selectedClientId: '',

            adminLoginProcess: ((this.params.token ? this.params.token : '') !== ""),
            newPasswordRequired: false,
            passwordExpired: false,
            showForgotPasswordDialog: false,
            showForgotUsernameDialog: false,
            showResetPwd: forgotpasswordtoken != null && forgotpasswordtoken != '' && username != null && username != '',
            showChangePwd: false,
            isBatteryPortal: false,
            showRegisterForm: false,
            defaultCulture: null,
            culture: { value: 'en-US', label: 'English' },
            cultureList: [
                { value: 'en-US', label: 'English' },
            ],
            isSigningIn: false,
        }
        this.passTimer = null
    }

    params = queryString.parse(this.props.location.search)

    cleanForgotPasswordParamsAndStayOnLogin = () => {
        const { location, navigate } = this.props;
        const query = new URLSearchParams(location.search || '');
        query.delete('username');
        query.delete('forgotpasswordtoken');
        const nextSearch = query.toString();
        navigate(`${location.pathname}${nextSearch ? `?${nextSearch}` : ''}`, { replace: true });
    }

    isScanQR = window.location.pathname.indexOf('/req-qr/login') > -1;
    isQRCreating = window.location.pathname.indexOf('/req-qr/create/login') > -1;
    isQREditing = window.location.pathname.indexOf('/req-qr/edit/login') > -1;
    isReqTmptId = this.params.rId ? Number.parseInt(this.params.rId) : 0;
    isDealerRegistration = window.location.pathname.indexOf('/dealer-registration') > -1;

    isLoginByCentralPortalLink = this.params.pId ? false : true;

    publicPaths = [
        { path: '/deny', ignoreIfAuth: true },
        { path: '/404', ignoreIfAuth: true },
        { path: '/login', ignoreIfAuth: true },
        { path: '/logout' },
        { path: '/forgot-password' },
        { path: '/reset-password' },
    ]

    async componentDidMount() {
        console.log('Application initialize....')
        window.addEventListener('beforeunload', (event) => {
            const { location } = this.props
            const { hash, pathname, search } = location;
            let prevURL = `${pathname}${search ? '?' + search : ''}`;
            console.log(hash, 'prevURL', prevURL)
            // if (!environment.production) {
            cacheService.setCache('__prevURL', prevURL);
            // }
        })

        let prevURL = cacheService.getCache('__prevURL')
        console.log('prevURL', prevURL)

        if (!this.state.portalId) {
            this.props.GET_PORTAL_LOGO()
        }

        let localLang = 'en-US'
        const selectedLang = cacheService.getCache('selectedLang');
        const cultureList = cacheService.getCache('cultureList') || [];
        const isCultureMissingLangId = cultureList?.length ? cultureList.some(culture => !culture?.langId) : false;
        if (!selectedLang || !cultureList || !cultureList?.length || isCultureMissingLangId) {
            localLang = getLang(this.state.portalId)

            const cultureInfo = await this.props.GET_DEFAULT_CULTURE({ portalId: this.state.portalId });
            if (cultureInfo && cultureInfo.shortCut) {
                localLang = cultureInfo.shortCut
                this.setState({ defaultCulture: cultureInfo });
            }
            const {code, cultureList } = await getLanguageFromLocation()
            if (code && cultureList?.length) {
                localLang = code
                const cultureListOptions = cultureList.filter(culture => culture?.cultureInfo?.shortCut).map(culture => ({ value: culture?.cultureInfo?.shortCut, label: culture?.cultureInfo?.name, langId: culture?.cultureId }))
                const foundCulture = cultureListOptions.find(culture => culture.value === code)
                if (foundCulture) {
                    this.setState({ culture: { value: foundCulture.value, label: foundCulture.label, langId: foundCulture.langId }, cultureList: cultureListOptions });
                    cacheService.setCache('cultureList', cultureListOptions);
                }
            }
            cacheService.setCache('selectedLang', localLang);
            
        } else {
            localLang = selectedLang
            this.setState({ cultureList: cultureList });
            const foundCulture = cultureList.find(culture => culture.value === localLang)
            if (foundCulture) {
                this.setState({ culture: { value: foundCulture.value, label: foundCulture.label, langId: foundCulture.langId }});
            }
        }
        console.log('selectedLang', localLang, selectedLang);
        
        getJsonLanguage(localLang, this.state.portalId)
        getMasterDataTranslation(localLang, this.state.portalId)

        this.props.GET_CLIENT_TERMS({ clientId: this.state.clientId, portalId: this.state.portalId })
        if (!this.props.programData || !Object.keys(this.props.programData).length) {
            await this.props.GET_PROGRAM_DATA({ portalId: this.state.portalId, clientId: this.state.clientId });
        }
        if (this.props.programData?.portalCategoryInfo?.isBatteryPortal) {
            this.setState({ isBatteryPortal: true });
        }

        if (this.isDealerRegistration) {
            this.setState({ showRegisterForm: true });
        }
        let { token, userId, userType, cId, pId, portalType } = this.params
        if (token && userId && userType && cId && pId && portalType) {
            this.setState({ readyToUseReason: "Please wait", compDidMount: true });
            this.processAdminLogin({ token, userId, userType, cId, pId, portalType });
        }
        else {
            if (this.props.programData.readyToUse === false) {
                this.setState({ readyToUseReason: this.props.programData.readyToUseReason, compDidMount: true });
            }
            else {
                this.setState({ compDidMount: true });
            }
            console.log('pathname', this.props.location.pathname)
            if ('/login' === this.props.location.pathname && Auth.token && !Auth.isTokenExpired) {
                this.redirectTo()
            }
        }
    }

    onChangeLanguage = (selectedOption) => {
        this.setState({ culture: selectedOption })
        const { value } = selectedOption
        if (value) {
            cacheService.setCache('selectedLang', value);
            getJsonLanguage(value, this.state.portalId)
            getMasterDataTranslation(value, this.state.portalId)
        }
    }

    onSSOSignIn = async (providerName) => {
        const { portalId, clientId } = this.state

        let ssoData = await this.props.FETCH_SAML_SSO_AUTHENTICATE_URL({ portalId, clientId, providerName })
        console.log('ssoData', ssoData)
        if (ssoData) {
            if (ssoData.authUrl) {
                console.log(`ssoData URL`, ssoData.authUrl)
                window.location.href = ssoData.authUrl;
            } else {
                let error = ssoData.message || 'Something went wrong!'
                this.setState({ error })
                //toast.error(error)
            }
        }
    }

    onChangeInput = (event) => {
        this.setState({
            error: '',
            portalsSameUser: [],
            selectedPortalId: '',
        })
        let { name, value } = event.target
        if (event.target.type == 'checkbox') value = event.target.checked;

        this.setState({
            [name]: value
        }, () => { this.onValidateAccount() })
    }

    onValidateAccount = () => {
        const { t, } = this.props
        const { username, password, } = this.state
        let error = ''
        if (!username || username.trim().length === 0) {
            error = t('MsgErrorUsername')
        } else if (username.length < 2) {
            error = t('MsgErrorMinimum2Char')
        } else if (!password || password.trim().length === 0) {
            error = t('MsgErrorPassword')
        }

        this.setState({ error })
        if (error) {
            // toast.warn(error)
            return false
        }
        return true
    }

    onValidateTerm = () => {
        const { t, termsPrivacy } = this.props
        const { acceptTerms } = this.state
        let error = ''
        if (!acceptTerms) {
            error = (termsPrivacy && termsPrivacy.isShowTermLink ? t(`MsgErrorPleaseAcceptPrivacyPolicyTerms`) : t(`MsgErrorPleaseAcceptPrivacyPolicy`))
        }

        this.setState({ error })
        if (error) {
            toast.warn(error); //,{className:'toast_basic'}
            return false
        }
        return true
    }

    isInGroupQRGenerator = () => {
        return (Auth.isQRGenerater || Auth.isQRCodeGen || false)
    }

    redirectTo() {
        if (Auth.token && !Auth.isTokenExpired) {
            let searchConditions = ''
            if (Auth.portalId && Auth.clientId) {
                searchConditions = `?pId=${Auth.portalId}&cId=${Auth.clientId}`
            }

            let menuItems = FILTER_PERMISSION(SIDE_MENU_ITEMS(), Auth.hasRightView, '')
            let firstPath = '/dashboard/home'
            if (menuItems?.length) {
                let pathItem = menuItems.find( ie => ie?.path?.startsWith('/')) 
                if (pathItem) {
                    firstPath = pathItem.path
                }
            }
            // if ((Auth.isQRGenerater || Auth.isSuperUser) && (this.isQRCreating || (this.isQREditing && this.isReqTmptId))) {
            // To be able to add new qr code => a normal user has to be in portal group which have QR code generator right
            if (this.isInGroupQRGenerator() && (this.isQRCreating || (this.isQREditing && this.isReqTmptId))) {
                if (this.isQRCreating) {
                    this.props.navigate(`/dashboard/requests/req-qr${this.props.location.search}`);
                } else {
                    this.props.navigate(`/dashboard/requests/req-qr/${this.isReqTmptId}${this.props.location.search}`);
                }
            } else {
                this.props.navigate(`${firstPath}${this.props.location.search || searchConditions}`);
            }
        }
    }

    onLogInUser = async (event) => {
        const { t } = this.props;
        const { username, password, portalId, clientId, acceptTerms, rememberMe } = this.state
        this.setState({
            error: '', newPasswordRequired: false, passwordExpired: false
        })

        let valid = this.onValidateAccount()
        if (!valid) {
            return
        }
        valid = this.onValidateTerm()
        if (!valid) {
            return
        }

        let payload = {
            username,
            password,
            portalId,
            clientId,
            acceptTerms
        }

        if (!portalId && !clientId && this.state.portalsSameUser && this.state.portalsSameUser.length && this.state.selectedPortalId) {
            payload.portalId = this.state.selectedPortalId
            payload.clientId = this.state.selectedClientId
            payload.isLoginByCentralUrl = true
        }

        this.setState({ isSigningIn: true })
        let result
        try {
            result = await this.props.SET_USER_LOGIN(payload)
        } finally {
            this.setState({ isSigningIn: false })
        }

        let { nextLoginTryTime, } = result;
        const mulPortals = (this.props.authErrorCode === 'PORTAL_SAME_USER')
        const passwordExpired = (this.props.authErrorCode === 'PASSWORD_EXPIRED')
        const newPasswordRequired = (this.props.authErrorCode === 'NEW_PASSWORD_REQUIRED')
        const invalidCredentials = (this.props.authErrorCode === "INVALID_CREDENTIALS")
        const accountInactive = (this.props.authErrorCode === "LOGIN-ACCOUNT-INACTIVE")
        const accountNotVerified = (this.props.authErrorCode === "LOGIN-ACCOUNT-NOT-VERIFIED")
        const error = this.props.authLoginError || '';

        this.setState({
            nextLoginTryTime, newPasswordRequired, passwordExpired, error
        })

        this.props.SET_LOGIN_AUTH_ERROR(null)

        if (nextLoginTryTime > 0) {
            this.setState({
                showLoginTimer: true,
                logRemainTimerMin: parseInt(nextLoginTryTime / 60),
                logRemainTimerSec: parseInt(nextLoginTryTime % 60),
                error: '',
            })
            if (error) {
                toast.warn(error)
            }
            return
        }
        if (invalidCredentials) {
            this.setState({
                error: t('MsgErrorInvalidCredentials') || 'Invalid Credentials!'
            })
            return
        }
        if (accountInactive) {
            this.setState({
                error: t('MsgErrorAccountInactive') || 'Account Inactive!'
            })
            return
        }
        if (accountNotVerified) {
            this.setState({
                error: t('MsgErrorAccountNotVerified') || 'Account Not Verified!'
            })
            return
        }
        if (passwordExpired) {
            this.setState({
                passwordExpired,
                error: t('MsgErrorPasswordExpired') || 'The Password Expired!'
            })
            return
        }
        if (newPasswordRequired) {
            this.setState({
                newPasswordRequired,
                error: t('MsgErrorNewPasswordRequired') || 'New Password Required!'
            })
            return
        }
        if (mulPortals) {
            const portalsSameUser = (this.props.portalsSameUser || [])
            this.setState({ portalsSameUser })
            return
        }

        await this.userLoggedIn()

        setTimeout(() => {
            this.redirectTo();
        }, 500)

        let keysToRemove = ['selectedRequestType', 'selectedStatus', 'selectedCountry', 'selectedPo', 'selectedRegion'];
        keysToRemove.forEach(k => cacheService.removeCache(k));
        if (rememberMe) {
            cacheService.setCache(`Me_${portalId}`, username)
        }
    }

    async userLoggedIn() {
        if (Auth.token && !Auth.isTokenExpired) {
            let localLang = (Auth.culture && Auth.culture.shortCut) || getLang(Auth.portalId)
            let countryCode = localLang.toUpperCase()
            Auth.setUserCountryShortCut(countryCode);

            // getJsonLanguage(localLang, Auth.portalId)
            // getMasterDataTranslation(localLang, Auth.portalId)
            // getPortalDataTranslation(localLang, Auth.portalId)

            await Promise.all([
                this.props.COUNTRY_UOM_DATA({ shortCut: countryCode }),
                this.props.GET_PROGRAM_DATA({ portalId: Auth.portalId, clientId: Auth.clientId }),
                this.props.GET_USER_GROUP_BY_USERID({
                    userId: Auth.userId,
                    portalId: Auth.portalId,
                    clientId: Auth.clientId,
                })
            ])
            if (this.props.countryUOM && this.props.countryUOM.multiplier) {
                Auth.setUOMMultiplier(this.props.countryUOM);
            }

        }
    }

    processAdminLogin = async (payload) => {

        await this.props.SET_LOGIN_ADMIN_TOKEN(payload);

        if (this.props.authLoginError) {
            this.setState({ error: this.props.authLoginError })
            return this.props.SET_LOGIN_AUTH_ERROR(null);
        }

        await this.userLoggedIn()

        setTimeout(() => {
            if ((Auth.token && !Auth.isTokenExpired)) {
                let searchConditions = ''
                if (Auth.portalId && Auth.clientId) {
                    searchConditions = `?pId=${Auth.portalId}&cId=${Auth.clientId}`
                }
                this.props.navigate(`/dashboard${searchConditions}`);
            }
        }, 1500)
        let keysToRemove = ['selectedRequestType', 'selectedStatus', 'selectedCountry', 'selectedPo', 'selectedRegion'];
        keysToRemove.forEach(k => cacheService.removeCache(k));
    }

    isTimerClosed = () => {
        this.setState({
            showLoginTimer: false,
            logRemainTimerMin: 0,
            logRemainTimerSec: 0,
            error: null
        })
    }

    onEnter = (e) => {
        if (e.keyCode === 13) {
            this.onLogInUser()
        }
    }

    selectPortal = (portalE) => {
        const found = this.state.portalsSameUser.find(e => e.portalId === portalE.value);
        if (found && found.portalId && found.clientId) {
            this.setState({
                selectedClientId: found.clientId,
                selectedPortalId: found.portalId
            })
        }
    }

    onQrCompleted = () => {
        if (this.state.passwordExpired) {
            let error = 'Your account password is already expired, please change it now'
            this.setState({ error })
            //toast.warn(error)
            this.setState({ showChangePwd: true })
        } else {
            this.redirectTo()
        }
    }
    onReloadPage() {
        window.location.reload()
    }

    passTimer = null
    showPass() {
        if (this.passTimer) {
            clearTimeout(this.passTimer)
        }
        this.passTimer = null
        this.setState({ isShowPwd: true })
    }
    hiddenPass() {
        if (this.passTimer) {
            clearTimeout(this.passTimer)
        }
        this.passTimer = setTimeout(() => {
            this.setState({ isShowPwd: false })
        }, 1000)
    }

    render() {
        // const timestamp = new Date().getTime();
        const { termsPrivacy, t } = this.props;
        let ssoValue = (this.props.programData && this.props.programData.ssoEnability) || [];
        if (ssoValue.length > 0) {
            ssoValue = ssoValue[0];
        } else {
            ssoValue = "";
        }
        ++this.childKey;
        return (
            <Aux>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col-md-12 col-lg-4">
                        <div className="row d-flex space-">
                        <div className="login-header col-md-6">
                            <img style={{ maxWidth: '4.688rem' }} src={portalLogoUrl()} />
                            <span className="splitter"></span>
                            <span className="title">{t('CustomerPortal')}</span>
                        </div>
                            <div className="col-md-6 d-flex justify-content-end align-items-end p-0">
                            <div className="d-flex align-items-center" style={{ 
                                marginRight: window.innerWidth >= 1800 ? '8.125rem' : window.innerWidth >= 1600 ? '6.25rem' : window.innerWidth >= 1400 ? '5rem' : '3.125rem'
                            }}>
                                <Select
                                    className="cp-select-box"
                                    name="language" 
                                    placeholder={t(`SelectLanguage`)}
                                    menuPlacement="top"
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minWidth: '7.5rem',
                                            borderRadius: '0.25rem',
                                            borderColor: '#ced4da'
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            fontSize: '1rem',
                                            color: '#6c757d'
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected ? '#007bff' : 'white',
                                            color: state.isSelected ? 'white' : 'black',
                                            '&:hover': {
                                                backgroundColor: state.isSelected ? '#0056b3' : '#f8f9fa'
                                            }
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            marginBottom: '0.5rem',
                                            marginTop: 0
                                        })
                                    }}
                                    options={this.state.cultureList}
                                    value={this.state.culture}
                                    onChange={this.onChangeLanguage}
                                />
                            </div>
                        </div>
                        </div>
                        <div className="row">
                            <div className="panel col-md-12">
                                {(this.props.session && this.props.mfaType) ?
                                    <div>
                                        <QRCodeLogin portalId={this.state.portalId} clientId={this.state.clientId}
                                            username={this.state.username} password={this.state.password}
                                            {...this.props} onNext={() => { this.onQrCompleted() }}></QRCodeLogin>
                                    </div>
                                    :
                                    <div>
                                        <h4 className="signin-text">{t('SignIn')}</h4>
                                        <div className="input-group">
                                            <Input className="cp-input-box" type="text" id="usernameInput"  placeholder={t('PlaceholderUsernameOrEmail')}
                                                onKeyDown={this.onEnter}
                                                name="username" value={this.state.username} required onChange={this.onChangeInput} autoFocus /*style={{ maxWidth: "31.25rem" }}*/ />
                                        </div>
                                        <br />
                                        <div className="input-group">
                                            <Input className="cp-input-box" type={this.state.isShowPwd ? 'text' : 'password'} style={{ borderRight: "none", /*maxWidth: "31.25rem"*/ }} name="password" id="passwordInput"
                                                onKeyDown={this.onEnter}
                                                placeholder={t('PlaceholderPassword')} value={this.state.password} required onChange={this.onChangeInput}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text" style={{ background: "none" }} onMouseLeave={() => { this.hiddenPass() }} onMouseUp={() => { this.hiddenPass() }} onMouseDown={() => { this.showPass() }}>{this.state.isShowPwd ? <i className="fas fa-eye"></i> : <i className="fas fa-eye-slash"></i>}</span>
                                            </div>
                                        </div>
                                        <br />
                                        <label className="accept-term">
                                            <input type='checkbox' className='customCheckbox' name="acceptTerms"
                                                onChange={this.onChangeInput} /> <span className="accept-term required">
                                                <span className="accept-term">{t('LabelAccept')}&nbsp;<a className='lnk-btn' style={{ textDecoration: 'none', fontSize: '1rem' }} rel="noopener noreferrer" href="https://www.sktes.com/data-privacy" target="_blank">{t('NavLinkPolicy')} </a>
                                                    {/* {(termsPrivacy && termsPrivacy.isShowTermLink) ? (
                                                        <span>{t('LabelAnd')} <a className='lnk-btn' style={{ textDecoration: 'none', fontSize: '1rem' }} href={`/terms?pId=${this.state.portalId}`} target="_blank" rel="noopener noreferrer">{t('NavLinkTerm')} </a></span>
                                                    ) : null} */}
                                                </span>
                                            </span></label>
                                        <br />
                                        <label className="accept-term">
                                            <input type='checkbox' className='customCheckbox' name="rememberMe"
                                                onChange={this.onChangeInput} /> <span className="accept-term">{t('RememberUsername')}</span> </label>

                                        <div className="mt-1" style={{ minHeight: '3.125rem', }}>
                                            {this.state.showLoginTimer ? (
                                                <div className="row">
                                                    <div className="col-12">
                                                        <Timer initialMinute={this.state.logRemainTimerMin} initialSecond={this.state.logRemainTimerSec} isTimerClosed={() => this.isTimerClosed()}></Timer>
                                                    </div>
                                                </div>
                                            ) : null}

                                            {this.state.compDidMount === true && this.state.readyToUseReason !== "" &&
                                                <div className="col-12">
                                                    <MineError message={this.state.readyToUseReason}></MineError>
                                                </div>
                                            }

                                            <MineError message={this.state.error}></MineError>
                                        </div>

                                        <div>
                                            <Button
                                                disabled={this.state.isSigningIn || this.state.showLoginTimer || (this.state.compDidMount === true && this.state.readyToUseReason !== "")}
                                                color="primary"
                                                className="btn-block btn-default rad-3"
                                                size="lg"
                                                type="button"
                                                onClick={this.onLogInUser}
                                            >
                                                {this.state.isSigningIn ? (
                                                    <><FontAwesomeIcon icon={faSpinner} spin className="me-2" />{t('SignIn')}</>
                                                ) : t('SignIn')}
                                            </Button>
                                            {this.state.isBatteryPortal ? <Button disabled={this.state.showLoginTimer} className="btn-block btn-secondary rad-3" size="lg" type="button" onClick={() => { window.open(`${window.location.origin}/dealer-registration?pId=${this.state.portalId}`, '_blank') }}>{t('Register')}</Button> : null}
                                        </div>

                                        {(this.props.programData && this.props.programData.isSsoEnable && this.props.programData.ssoEnability && ssoValue !== "") && !this.isLoginByCentralPortalLink ? (
                                            <div className="mg-t7">
                                                <Button color="primary" className="btn-block btn-primary-dark" size="lg" type="button" onClick={() => this.onSSOSignIn(ssoValue)}>{ssoValue.toUpperCase()} {t('SSOSignIn')}</Button>
                                            </div>) : null
                                        }
                                        <div className="mt-3 text-center row">
                                            <div className="col-5 text-right">
                                                <a className="lnk-btn" href='javascript: void(0);' onClick={() => { this.setState({ showForgotUsernameDialog: true }) }} style={{ pointerEvents: (this.state.compDidMount === true && this.state.readyToUseReason !== "") ? "none" : "auto" }}>{t('NavLinkForgotUsername')}</a>
                                            </div>
                                            <div className="col-1">
                                                <div style={{ borderRight: '0.125rem solid #eee', margin: '0.313rem 0' }}>&nbsp;</div>
                                            </div>
                                            <div className="col-5 text-left">
                                                <a className="lnk-btn" href='javascript: void(0);' onClick={() => { this.setState({ showForgotPasswordDialog: true }) }} style={{ pointerEvents: (this.state.compDidMount === true && this.state.readyToUseReason !== "") ? "none" : "auto" }}>{t('NavLinkForgotPassword')}</a>
                                            </div>


                                        </div><br />
                                        {(this.state.newPasswordRequired || this.state.passwordExpired) ? (
                                            <div className="row">
                                                <div className="col-12">
                                                    {this.state.newPasswordRequired ?
                                                        <Button color="outline-warning" size="lg" className="btn-block" onClick={() => { this.setState({ showChangePwd: true }) }} >
                                                            Change Password
                                                        </Button> :
                                                        <Button color="outline-warning" size="lg" className="btn-block" onClick={() => { this.setState({ showChangePwd: true }) }} >
                                                            Reset Password
                                                        </Button>
                                                    }

                                                </div>
                                            </div>
                                        ) : null}

                                        <FooterSignInPopup
                                        pId={this.state.portalId}
                                        ></FooterSignInPopup>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 d-none d-md-none d-lg-block" style={{ padding: 0 }}>
                        <div className="login-bg">
                            <img style={{height: '100%', width: '100%' }} src={getPortalBackgroundUrl()} />
                        </div>
                    </div>
                    
                </div>

                {
                    (this.state.showForgotUsernameDialog) ? (
                        <ForgotUsernamePopup id={'popup-forgot-username'} portalId={this.state.portalId} clientId={this.state.clientId} onHide={() => { this.setState({ showForgotUsernameDialog: false }) }} ></ForgotUsernamePopup>
                    ) : null
                }
                {
                    (this.state.showForgotPasswordDialog) ? (
                        <ForgotPasswordPopup id={'popup-forgot-password'} portalId={this.state.portalId} clientId={this.state.clientId} key={`forgot-pwd-${this.childKey}`} onHide={() => { this.setState({ showForgotPasswordDialog: false }) }} onShowForgotUsername={() => { 
                            this.setState({ showForgotPasswordDialog: false, showForgotUsernameDialog: true });
                        }} ></ForgotPasswordPopup>
                    ) : null
                }
                <ResetPasswordPopup id={'popup-reset-password'} portalId={this.state.portalId} clientId={this.state.clientId} username={this.state.username} show={this.state.showResetPwd} onHide={() => { this.setState({ showResetPwd: false }) }} onNext={() => { this.setState({ showResetPwd: false, showSuccessChangepass: true }) }}></ResetPasswordPopup>
                <ChangePasswordPopup id={'popup-change-password'} portalId={this.state.portalId} clientId={this.state.clientId} username={this.state.username} password={this.state.password} show={this.state.showChangePwd} onHide={() => { this.setState({ showChangePwd: false }) }} onNext={() => { this.setState({ showChangePwd: false, showSuccessChangepass: true }) }}></ChangePasswordPopup>

                {(this.state.showSuccessChangepass) ? (
                    <SuccessDialog
                        id={'dialog-reset-password-success'}
                        content={t('TxtResetPasswordSuccess')}
                        onHide={() => {
                            this.setState({ showSuccessChangepass: false }, () => {
                                this.cleanForgotPasswordParamsAndStayOnLogin();
                            });
                        }}
                    ></SuccessDialog>
                ) : null}

                {
                    (this.state.showRegisterForm) ? (
                        <RegisterForm id={'register-form'} portalId={this.state.portalId} clientId={this.state.clientId} onHide={() => { this.setState({ showRegisterForm: false }) }} programCulturesList={this.props.programCulturesList} defaultCulture={this.state.defaultCulture}></RegisterForm>
                    ) : null
                }

            </Aux >
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SignIn)));